import { useState, useId } from "react";
import { Dialog, Tab } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Container } from "../Container";
import { siteSettings } from "../../settings";
import "../../styles/hero.css";
import { Button } from "../Button";
import screenshotProfitLoss from "../../images/screenshots/profit-loss.png";
import screenshotDashboard from "../../images/screenshots/dashboard.png";
import screenshotMobile from "../../images/screenshots/dashboard-mobile.png";

const navigation = [
  { name: "Product", href: "#" },
  { name: "Features", href: "#" },
  { name: "Marketplace", href: "#" },
  { name: "Company", href: "#" },
];

const features = [
  {
    name: "Reporting",
    summary: "Stay on top of things with always up-to-date reporting features.",
    description:
      "We talked about reporting in the section above but we needed three items here, so mentioning it one more time for posterity.",
    image: screenshotDashboard,
    imageTwo: screenshotMobile,
    icon: function ReportingIcon() {
      let id = useId();
      return (
        <>
          <defs>
            <linearGradient
              id={id}
              x1="11.5"
              y1={18}
              x2={36}
              y2="15.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".194" stopColor="#fff" />
              <stop offset={1} stopColor="#6692F1" />
            </linearGradient>
          </defs>
          <path
            d="m30 15-4 5-4-11-4 18-4-11-4 7-4-5"
            stroke={`url(#${id})`}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    },
  },
  {
    name: "Inventory",
    summary:
      "Never lose track of what’s in stock with accurate inventory tracking.",
    description:
      "We don’t offer this as part of our software but that statement is inarguably true. Accurate inventory tracking would help you for sure.",
    image: screenshotDashboard,
    imageTwo: screenshotMobile,
    icon: function InventoryIcon() {
      return (
        <>
          <path
            opacity=".5"
            d="M8 17a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2Z"
            fill="#fff"
          />
          <path
            opacity=".3"
            d="M8 24a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2Z"
            fill="#fff"
          />
          <path
            d="M8 10a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2Z"
            fill="#fff"
          />
        </>
      );
    },
  },
  {
    name: "Contacts",
    summary:
      "Organize all of your contacts, service providers, and invoices in one place.",
    description:
      "This also isn’t actually a feature, it’s just some friendly advice. We definitely recommend that you do this, you’ll feel really organized and professional.",
    image: screenshotDashboard,
    imageTwo: screenshotMobile,
    icon: function ContactsIcon() {
      return (
        <>
          <path
            opacity=".5"
            d="M25.778 25.778c.39.39 1.027.393 1.384-.028A11.952 11.952 0 0 0 30 18c0-6.627-5.373-12-12-12S6 11.373 6 18c0 2.954 1.067 5.659 2.838 7.75.357.421.993.419 1.384.028.39-.39.386-1.02.036-1.448A9.959 9.959 0 0 1 8 18c0-5.523 4.477-10 10-10s10 4.477 10 10a9.959 9.959 0 0 1-2.258 6.33c-.35.427-.354 1.058.036 1.448Z"
            fill="#fff"
          />
          <path
            d="M12 28.395V28a6 6 0 0 1 12 0v.395A11.945 11.945 0 0 1 18 30c-2.186 0-4.235-.584-6-1.605ZM21 16.5c0-1.933-.5-3.5-3-3.5s-3 1.567-3 3.5 1.343 3.5 3 3.5 3-1.567 3-3.5Z"
            fill="#fff"
          />
        </>
      );
    },
  },
];

function FeaturesDesktop() {
  return (
    // hidden
    <Tab.Group as="div" className="  lg:block">
      {({ selectedIndex }) => (
        <>
          {/* <Tab.List className="grid grid-cols-3 gap-x-8">
            {features.map((feature, featureIndex) => (
              <Feature
                key={feature.name}
                feature={{
                  ...feature,
                  name: (
                    <Tab className="[&:not(:focus-visible)]:focus:outline-none">
                      <span className="absolute inset-0" />
                      {feature.name}
                    </Tab>
                  ),
                }}
                isActive={featureIndex === selectedIndex}
                className="relative"
              />
            ))}
          </Tab.List> */}
          {/* <Tab.Panels className="relative mt-20 overflow-hidden rounded-4xl bg-slate-200 px-14 py-16 xl:px-16"> */}
          <div className=" overflow-hidden w-full md:hidden">
            {features.map(
              (feature, featureIndex) =>
                // <Tab.Panel
                //   static
                //   key={feature.name}
                //   className={clsx(
                //     "px-5 transition duration-500 ease-in-out [&:not(:focus-visible)]:focus:outline-none",
                //     featureIndex !== selectedIndex && "opacity-60"
                //   )}
                //   style={{ transform: `translateX(-${selectedIndex * 100}%)` }}
                //   aria-hidden={featureIndex !== selectedIndex}
                // >
                featureIndex === 1 && (
                  <div
                    className="max-w-[73.75rem] max-h-[600px] pt-10 "
                    style={{ margin: "0 auto" }}
                  >
                    <img
                      className="w-full ml-8  "
                      src={feature.imageTwo}
                      alt=""
                      // sizes="73.75rem"
                    />
                  </div>
                )
              // </Tab.Panel>
            )}
          </div>

          <div className=" overflow-hidden w-full hidden md:block">
            {features.map(
              (feature, featureIndex) =>
                // <Tab.Panel
                //   static
                //   key={feature.name}
                //   className={clsx(
                //     "px-5 transition duration-500 ease-in-out [&:not(:focus-visible)]:focus:outline-none",
                //     featureIndex !== selectedIndex && "opacity-60"
                //   )}
                //   style={{ transform: `translateX(-${selectedIndex * 100}%)` }}
                //   aria-hidden={featureIndex !== selectedIndex}
                // >
                featureIndex === 1 && (
                  <div
                    className="max-w-[73.75rem]  pt-10 "
                    style={{ margin: "0 auto" }}
                  >
                    <img
                      className="w-full"
                      src={feature.image}
                      alt=""
                      // sizes="73.75rem"
                    />
                  </div>
                )
              // </Tab.Panel>
            )}
          </div>
          {/* <div className="pointer-events-none absolute inset-0 rounded-4xl ring-1 ring-inset ring-slate-900/10" /> */}
          {/* </Tab.Panels> */}
        </>
      )}
    </Tab.Group>
  );
}

export default function HeroTwo() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    // <div className="bg-white">
    <Container className="pb-16 pt-20 text-center lg:pt-32">
      <div className="relative isolate">
        {/* <div
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div> */}
        <div className="lg:pb-40">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl text-center">
              <h1 className="mx-auto max-w-4xl font-sans text-5xl font-semibold tracking-tight text-white sm:text-7xl hero_text">
                <span> {""} Your</span>
                <span> {""} gateway</span>
                <span> {""} to</span>
                <span> {""} global</span>
                <span> {""} financial </span>
                <span> {""} markets </span>
              </h1>
              <p className="mx-auto mt-6 max-w-2xl text-lg tracking-tight text-[#CECFD1] hero_support">
                Seamlessly merging complexity with ease, {siteSettings.name}{" "}
                offers top-notch security, 24/7 support, and an intuitive
                platform for your trading needs.
              </p>
              <div className="mt-10 flex justify-center gap-x-6 hero_buttons">
                <Button href={`${siteSettings.appLink}/register`}>
                  Get started
                </Button>
                <Button
                  href={`${siteSettings.appLink}/dashboard`}
                  variant="outline"
                >
                  <span>Log in</span>
                </Button>
              </div>
            </div>
            {/* <div className="mt-16 flow-root sm:mt-24 hero_buttons"> */}
            {/* <div className="-m-2 rounded-xl bg-gray-900/5 p-2 ring-1 ring-inset ring-gray-900/10 lg:-m-4 lg:rounded-2xl lg:p-4">
                <img
                  src="https://tailwindui.com/img/component-images/project-app-screenshot.png"
                  alt="App screenshot"
                  width={2432}
                  height={1442}
                  className="rounded-md shadow-2xl ring-1 ring-gray-900/10"
                />
              </div> */}
            {/* <FeaturesDesktop /> */}
            {/* </div> */}
          </div>
        </div>
        {/* <div
          className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div> */}
      </div>
    </Container>
  );
}

{
  /* </div> */
}
